export default __webpack_public_path__ + "static/media/Screenshot (189).2b897d87.png";